export default __webpack_public_path__ + "static/media/hunger3.5a565f7b.png";